<tec-modal
	[isVisible]="true"
	[title]="'PROCESSES.DETAIL.MESSAGES_SENT' | translate"
	[tagImage]="{ icon: 'icon-message-circle', status: 'control' }"
	(closeEvent)="closeModal()"
>
	<ng-container body>
		<tec-toolbar [toolbar]="toolbar()" (formFilter)="onFilter($event)" />

		<tec-tile styling="thin">
			@if (messageRows().length > 0) {
				<div class="sent-messages-list">
					@for (row of messageRows(); track row.id) {
						<div
							class="sent-message-row"
							[class.sent-message-row--no-content]="!row.hasContent"
						>
							<tec-comment layout="thread" [comments]="[row.comment]" />
							@if (!row.hasContent) {
								<tec-empty-state
									class="sent-message-row__empty"
									size="sm"
									type="empty"
									[title]="'PROCESSES.DETAIL.MESSAGES.CONTENT_UNAVAILABLE' | translate"
								/>
							}
						</div>
					}
				</div>
			} @else {
				<tec-empty-state
					type="notresults"
					[title]="'PROCESSES.DETAIL.MESSAGES.EMPTY_TITLE' | translate"
					[description]="'PROCESSES.DETAIL.MESSAGES.EMPTY_DESCRIPTION' | translate"
				/>
			}
		</tec-tile>
	</ng-container>
</tec-modal>
